import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { generatePath } from 'react-router-dom';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { LeagueAvatar } from '@sorare/core/src/components/league/LeagueAvatar';
import { FOOTBALL_LEAGUES_SLUG } from '@sorare/core/src/constants/__generated__/routes';

import type { ScoutingCenterHeaderCompetitionButton_competition } from './__generated__/index.graphql';

type Props = {
  competition: ScoutingCenterHeaderCompetitionButton_competition;
};

export const CompetitionButton = ({ competition }: Props) => {
  return (
    <Button
      key={competition.slug}
      startIcon={
        <LeagueAvatar
          league={{
            slug: competition.slug,
            name: competition.displayName,
            avatarUrl: competition.logoUrl || undefined,
          }}
          size={20}
        />
      }
      color="quaternary"
      size="compact"
      to={generatePath(FOOTBALL_LEAGUES_SLUG, { slug: competition.slug })}
    >
      {competition.displayName}
    </Button>
  );
};

CompetitionButton.fragments = {
  competition: gql`
    fragment ScoutingCenterHeaderCompetitionButton_competition on Competition {
      slug
      displayName
      logoUrl
    }
  ` as TypedDocumentNode<ScoutingCenterHeaderCompetitionButton_competition>,
};
